import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import feathersClient from '../feathers-client';

Vue.use(VueRouter)

const routes = [
    {
        path: '/error',
        name: 'error',
        component: require("../components/Error").default
    },
    {
        path: window.obelix.url,
        name: 'editor',
        component: require("../components/JsEditor").default
    },
    {
        path: window.obelix.url + '/load/:compositionId',
        name: 'editorId',
        component: require("../components/JsEditor").default
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach(async  (to, from, next) => {
    if(to.name != 'error') {
        try {
            if (!window.obelix.jwt) {
                await store.dispatch('setEditorError', "Pas de jeton");
                next({ path: '/error' });
                return;
            }
            let user = store.getters['user']
            if (!user) {
                user = (await feathersClient.reAuthenticate()).user;
                if (!user) {
                    await store.dispatch('setEditorError', "Reconnexion impossible");
                    next({ path: '/error' });
                    return;
                }
                await store.dispatch('setUser', user);
            }

        } catch(error) {
            await store.dispatch('setEditorError', error);
            next('/error');
        }
    }

    next(); // make sure to always call next()!
});


export default router;

